module.exports = __webpack_public_path__ + "static/media/history_icon.30285f91.svg";